// DiabetesRiskCalculator.js
import React, { useEffect, useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Risiko Diabetes";
const DESCRIPTION =
  "Kalkulator risiko diabetes yang akurat: temukan kemungkinan Anda terkena diabetes dalam 7,5 tahun berdasarkan usia, berat badan, riwayat keluarga, dan gaya hidup! Alat yang disetujui secara medis dengan tips pencegahan untuk mengurangi risiko - terutama untuk tahap pradiabetes.";
const KEYWORDS =
  "kalkulator diabetes, risiko diabetes, indeks massa tubuh, kadar gula darah, kolesterol";
const OG_URL =
  "https://do-calculate.com/calculator/id/diabetes-risk-calculator/";
function DiabetesRiskCalculator() {
  const [age, setAge] = useState(0);
  const [sex, setSex] = useState(1);
  const [ethnicity, setEthnicity] = useState(1);
  const [physicalActivity, setPhysicalActivity] = useState(1);
  const [height, setHeight] = useState(0);
  const [weight, setWeight] = useState(0);
  const [bmi, setBMI] = useState(0);
  const [familyHistory, setFamilyHistory] = useState(1);
  const [highBloodPressure, setHighBloodPressure] = useState(0);
  const [result, setResult] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    if (height > 0 && weight > 0) {
      const heightInMeters = height / 100;
      const calculatedBMI = weight / (heightInMeters * heightInMeters);
      setBMI(calculatedBMI.toFixed(1));
    }
  }, [height, weight]);
  const calculateRiskScore = () => {
    let score = 0;
    score += parseInt(familyHistory, 10);
    score += parseInt(highBloodPressure, 10);
    const ageNum = parseInt(age, 10);
    if (ageNum >= 60) {
      score += 3;
    } else if (ageNum >= 50) {
      score += 2;
    } else if (ageNum >= 40) {
      score += 1;
    }
    if (parseInt(ethnicity, 10) === 1) {
      score += 1;
    }
    if (parseInt(physicalActivity, 10) === 0) {
      score += 1;
    }
    score += parseInt(sex, 10);
    const bmiNum = parseFloat(bmi);
    if (bmiNum >= 40) {
      score += 3;
    } else if (bmiNum >= 30) {
      score += 2;
    } else if (bmiNum >= 25) {
      score += 1;
    }
    return score;
  };
  const handleCalculate = () => {
    try {
      const score = calculateRiskScore();
      const riskMessage =
        score >= 5
          ? `Skor: ${score} - Anda berisiko tinggi terkena pradiabetes.`
          : `Skor: ${score} - Anda berisiko rendah terkena pradiabetes.`;
      setResult(`${riskMessage} Berdasarkan faktor-faktor yang Anda berikan.
        Jika skornya di bawah 5, itu dianggap berisiko rendah! `);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Hitung risiko diabetes dalam 7,5 tahun secara akurat menggunakan kalkulator komprehensif kami! Dengan alat canggih ini, Anda dapat mengevaluasi kemungkinan terkena diabetes dalam waktu dekat dengan memasukkan informasi kesehatan dasar seperti usia, jenis kelamin, tinggi badan, etnis, riwayat keluarga, tingkat aktivitas fisik, tekanan darah, indeks massa tubuh (BMI).
                </p>
                <p>
                  Mengapa Anda harus menggunakan Kalkulator Risiko Diabetes? Mengetahui risiko diabetes dapat membantu Anda mengambil langkah proaktif untuk menjaga kesehatan Anda dan mencegah penyakit kronis ini. Dengan memahami kemungkinan Anda terkena diabetes, Anda dapat membuat perubahan gaya hidup sehat, seperti mengikuti diet seimbang, berolahraga secara teratur, dan mengontrol berat badan, untuk mengurangi risiko diabetes.
                </p>
                <p>
                  Poin untuk setiap faktor risiko di bawah ini dijumlahkan untuk menghitung skor akhir. Misalnya, jika Anda menjawab "Ya" untuk pertanyaan "Apakah Anda memiliki ibu, ayah, saudara laki-laki, atau saudara perempuan yang menderita diabetes?", Anda mendapatkan satu poin di bawah "Riwayat Keluarga". Dan jika Anda menjawab "Tidak" untuk pertanyaan "Apakah Anda telah didiagnosis menderita tekanan darah tinggi?", Anda mendapatkan 0 poin di bawah "Tekanan Darah Tinggi", dan seterusnya untuk semua faktor risiko. Total 5 poin atau lebih menunjukkan risiko tinggi terkena tahap pradiabetes.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">Usia</label>
                      <input
                        type="number"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        placeholder="Masukkan usia Anda"
                        className="form-control"
                        style={{ width: "78%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="sex">Jenis Kelamin</label>
                      <select
                        id="sex"
                        value={sex}
                        onChange={(e) => setSex(e.target.value)}
                        className="form-control"
                        style={{ width: "78%" }}
                      >
                        <option value={1}>Laki-laki</option>
                        <option value={0}>Perempuan</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="ethnicity">Etnis</label>
                      <select
                        id="ethnicity"
                        value={ethnicity}
                        onChange={(e) => setEthnicity(e.target.value)}
                        className="form-control"
                        style={{ width: "78%" }}
                      >
                        <option value={1}>
                          Amerika Latin atau keturunan Afrika atau Asia
                        </option>
                        <option value={0}>Putih non-Hispanik</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="physicalActivity">
                        Tingkat Aktivitas Fisik
                      </label>
                      <select
                        id="physicalActivity"
                        value={physicalActivity}
                        onChange={(e) => setPhysicalActivity(e.target.value)}
                        className="form-control"
                        style={{ width: "78%" }}
                      >
                        <option value={1}>Aktif</option>
                        <option value={0}>Tidak Aktif</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="bloodPressure">
                        Apakah tekanan darah Anda tinggi?
                      </label>
                      <select
                        id="bloodPressure"
                        value={highBloodPressure}
                        onChange={(e) => setHighBloodPressure(e.target.value)}
                        className="form-control"
                        style={{ width: "78%" }}
                      >
                        <option value={1}>Ya</option>
                        <option value={0}>Tidak</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">Tinggi Badan (cm)</label>
                      <input
                        type="number"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                        placeholder="Masukkan tinggi badan Anda (dalam sentimeter)"
                        className="form-control"
                        style={{ width: "78%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">Berat Badan (kg)</label>
                      <input
                        type="number"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        placeholder="Masukkan berat badan Anda (dalam kilogram)"
                        className="form-control"
                        style={{ width: "78%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="bmi">
                        Indeks Massa Tubuh (BMI)
                      </label>
                      <input
                        id="bmi"
                        type="text"
                        value={bmi}
                        readOnly
                        className="form-control"
                        style={{ width: "78%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="familyHistory">
                        Riwayat Keluarga dengan Diabetes
                      </label>
                      <select
                        id="familyHistory"
                        value={familyHistory}
                        onChange={(e) => setFamilyHistory(e.target.value)}
                        className="form-control"
                        style={{ width: "78%" }}
                      >
                        <option value={1}>Ada riwayat keluarga</option>
                        <option value={0}>Tidak ada riwayat keluarga</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Error: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Persentase Risiko Diabetes:</h4>
                      <p className="text-white">{result}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Menghitung Risiko Diabetes</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Pendahuluan</h2>{" "}
                  </u>
                  <p>
                    Menghitung risiko diabetes membantu menentukan tingkat risiko terkena diabetes berdasarkan serangkaian faktor pribadi dan medis.
                  </p>
                  <p>
                    Faktor-faktor ini termasuk usia, jenis kelamin, etnis, tingkat aktivitas fisik, tekanan darah, tinggi badan, berat badan, dan riwayat keluarga dengan diabetes.
                  </p>
                  <div className="p-3 mb-2 bg-info">
                    Contoh: usia di atas 45 tahun, dengan riwayat keluarga diabetes.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Bagaimana Poin Dihitung?</h2>{" "}
                  </u>
                  <p>
                    Poin dihitung berdasarkan input pengguna dari informasi berikut:
                  </p>
                  <ul>
                    <li>Usia (misalnya, di atas 45 tahun dapat memberikan 2 poin)</li>
                    <li>Jenis kelamin (laki-laki mungkin memiliki risiko lebih tinggi)</li>
                    <li>Etnis (beberapa etnis lebih berisiko terkena diabetes)</li>
                    <li>Tingkat aktivitas fisik (kurang aktivitas meningkatkan poin)</li>
                    <li>Tekanan darah (tekanan darah tinggi meningkatkan poin)</li>
                    <li>Tinggi dan berat badan (untuk menghitung BMI)</li>
                    <li>Riwayat keluarga dengan diabetes (riwayat keluarga meningkatkan poin)</li>
                  </ul>
                  <p>
                    Jika poin melebihi 5, itu berarti risiko tinggi terkena diabetes.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    Contoh: seseorang dengan 6 poin berarti risiko tinggi.
                  </div>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Tips Pencegahan</h2>{" "}
                  </u>
                  <p>
                    Untuk menjaga kadar gula darah dalam kisaran normal, disarankan untuk mengikuti diet sehat dan meningkatkan aktivitas fisik.
                  </p>
                  <ul>
                    <li>Hindari makanan tinggi gula dan lemak.</li>
                    <li>Olahraga secara teratur.</li>
                    <li>Pertahankan berat badan yang sehat.</li>
                  </ul>
                  <p>
                    Juga disarankan untuk melakukan pemeriksaan rutin untuk memantau kadar gula darah dan tekanan darah.
                  </p>
                  <b>Contoh: berjalan kaki selama 30 menit setiap hari.</b>
                  <div className="p-3 mb-2 bg-info text-black">
                    Contoh: makan makanan seimbang dari sayuran dan protein.
                  </div>
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Pertanyaan Umum</h2>{" "}
                  </u>
                  <p>
                    Di sini Anda akan menemukan jawaban untuk beberapa pertanyaan umum tentang menghitung risiko diabetes.
                  </p>
                  <b>Contoh: Apa faktor risiko yang paling umum?</b>
                  <div className="p-3 mb-2 bg-info text-black">
                    Faktor seperti usia, obesitas, dan riwayat keluarga.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default DiabetesRiskCalculator;